import { createBrowserHistory } from "history";

// Makes possible to access history outside react components
export const history = createBrowserHistory();
